import type { ViewContextFilterValues } from '../createDefaultsFromViewContext';

export const CREATE_SURFACE_KIND = {
    modalOverList: 'modalOverList',
    createScreen: 'createScreen',
    none: 'none'
} as const;

export const EMPTY_FILTER_VALUES: ViewContextFilterValues = {};

/**
 * Fallback retention for create sessions opened as a modal over the list route.
 *
 * We currently cannot observe modal close events at this provider boundary, so this TTL acts as a
 * safety net to avoid keeping stale defaults forever while still allowing async field mounts to
 * inherit values reliably.
 */
export const MODAL_OVER_LIST_SESSION_TTL_MS = 30000;
